import { render, staticRenderFns } from "./NotFoundModule.vue?vue&type=template&id=30204aeb&scoped=true"
import script from "./NotFoundModule.vue?vue&type=script&lang=js"
export * from "./NotFoundModule.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30204aeb",
  null
  
)

export default component.exports